/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloUnidades from 'Infotrack@Modelos/smartStock/unidades';
import IUnidades from 'Infotrack@Modelos/smartStock/unidades/entidades/unidades';

export default class ControladorModeloUnidades {
    private modeloUnidades: ModeloUnidades;
    constructor() {
        this.modeloUnidades = new ModeloUnidades();
    }

    public consultarUnidades() {
        return this.modeloUnidades.consultarUnidades().then(({ data: { Entidades } }) => Entidades);
    }

    public consultarUnidadesCompuesta() {
        return this.modeloUnidades.consultarUnidadesCompuesta().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearUnidades(unidades: IUnidades) {
        await this.modeloUnidades.crearUnidades(unidades);
    }

    public async editarUnidades(unidades: IUnidades) {
        await this.modeloUnidades.editarUnidades(unidades);
    }
    public async eliminarUnidades(unidades: IUnidades) {
        await this.modeloUnidades.eliminarUnidades(unidades);
    }

    public async consultarUnidadesPorEmpresa(unidades: Partial<IUnidades>) {
        return (await this.modeloUnidades.consultarUnidadesCompuestaPorEmpresa(unidades)).data.Entidades;
    }

    public validarEntidad(unidades: IUnidades): boolean {
        if (unidades.TipoUnidadId === 0 || unidades.DescripcionUnidad === '' || unidades.Abreviatura === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarUnidadesFiltro(unidades: IUnidades) {
       return  (await this.modeloUnidades.consultarUnidadesFiltro(unidades)).data.Entidades;
    }

}
